module.exports = __webpack_public_path__ + "static/media/speaker.bfc3bde0.png";